import * as React from "react";
import { useSync } from "@grandvisionhq/lib-utils-w3c";
import { useWishlistContext } from "../../context.js";
const useWishlistId = (callback) => {
  const { localWishlist, setWishlist, removeWishlist } = useWishlistContext();
  const { broadcastUpdate } = useSync("wishlist_channel", callback);
  const updateWishlist = React.useCallback(
    (newWishlist) => {
      if (!localWishlist && newWishlist) {
        setWishlist(newWishlist);
      }
      broadcastUpdate();
    },
    [localWishlist, setWishlist, broadcastUpdate]
  );
  const clearWishlist = React.useCallback(() => {
    removeWishlist();
    broadcastUpdate();
  }, [removeWishlist, broadcastUpdate]);
  return {
    localWishlist,
    updateWishlist,
    clearWishlist
  };
};
export {
  useWishlistId
};
//# sourceMappingURL=use-wishlist-id.js.map
